import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);

const routes = [{
    path: "/",
    redirect: '/index',
},
{
    path: "/index",
    name: "index",
    component: () =>
        import("../views/index/index.vue"),
    meta: {
        title: '首页'
    }
},
{
    path: "/blogs",
    name: "blogs",
    component: () =>
        import("@/views/blog/index.vue"),
    meta: {
        title: '随笔'
    },
},
{
    path: "/detail",
    name: "detail",
    component: () =>
        import("@/views/detail/index.vue"),
    meta: {
        title: '文章详情'
    },
},
{
    path: "/assemble",
    name: "assemble",
    component: () =>
        import("@/views/assemble/index.vue"),
    meta: {
        title: '经典'
    },
},
{
    path: "/contribute",
    name: "contribute",
    component: () =>
        import("@/views/contribute/index.vue"),
    meta: {
        title: '投稿'
    },
},
{
    path: "/search",
    name: "search",
    component: () =>
        import("@/views/result/index.vue"),
    meta: {
        title: '搜索'
    },
},
{
    path: "/contact",
    name: "contact",
    component: () =>
        import("@/views/contact/index.vue"),
    meta: {
        title: '联系'
    },
},
]

const router = new VueRouter({
    routes
});
router.beforeEach((to, from, next) => {
    if (to.fullPath !== from.fullPath) {
        next();
    }

})
export default router;